module.exports = {
  appId: "6912b635-dc23-4741-8c3c-b2ac1d50275e",
  scopes:[
    "Channel.ReadBasic.All", //Read the names and descriptions of channels
    "ChannelMessage.Read.All", //Read user channel messages - Allows an app to read your 1 on 1 or group chat messages in Microsoft Teams, on your behalf.
    "Chat.Read", //Read user chat messages - Allows an app to read your 1 on 1 or group chat messages in Microsoft Teams, on your behalf.
    "Chat.ReadBasic", //Read names and members of user chat threads - Allows an app to read the members and descriptions of one-to-one and group chat threads, on your behalf.
    "Mail.Send", //Send mail as a user - Allows the app to send mail as you.
    "Team.ReadBasic.All",//Read the names and descriptions of teams
    "User.Read"//Sign in and read user profile
    ]  
};


//scopes: ["user.read", "Mail.Send","Team.ReadBasic.All","Chat.Read","Chat.ReadBasic"]
  //scopes: ["user.read", "Mail.Send","Team.ReadBasic.All","Chat.Read","Chat.ReadBasic","Chat.ReadWrite"]